<template>
	<b-form-input :id='id' v-model="value" class='table-control my-control' data-num='f_20' data-table='1' disabled></b-form-input>
</template>

<script>
	import {DB} from './../../../constants'
	// const LOCALFORESTRY = 'localforestrie_list.php'
	const LOCALFORESTRY = 'get_localforestry_by_id.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'localforestry',
		data: function () {
			return {
				value: '',
				id: `${this.type}_localforestry_${this.line_count}`,
				l: this.lf_id
			}
		},
		props: {
			line_count: 0,
			type: '',
			lf_id: '',
		},
		watch: {
			created: function () {
			//console.log(`set_localforestry_${this.line_count}`)
			EventBus.$on(`set_localforestry_${this.line_count}`, id => {
				//console.log(id)
				fetch(DB + LOCALFORESTRY + '?id=' + id)
				.then(data => data.json())
				.then(data => {
					//console.log(d, data)
					if (data) {
						this.value = data[0].name
					}
					else {
						this.value = ''
					}
				})
				.catch(err => console.log(err))
			})
		},
		beforeDestroy () {
			EventBus.$off(`set_localforestry_${this.line_count}`)
		}
	}
}
</script>


// WEBPACK FOOTER //
// localforestry.vue?34b248d3